import { useBreakpointValueGS } from 'hooks/useBreakpointValueGS';
import React, { PropsWithChildren } from 'react';
import { ScrollView, StyleSheet, Text, View } from 'react-native';
import theme from 'theme';

import HelpBackground from 'components/Help/HelpBackground';
import { HelperFooter } from 'components/Help/HelperFooter';

type HelpPageLayoutProps = { title?: string } & PropsWithChildren;

const HelpPageLayout: React.FC<HelpPageLayoutProps> = ({ title, children }) => {
  const paddingX = useBreakpointValueGS({ xl: 12, lg: 12, base: 0 });
  const contentSpacing = useBreakpointValueGS({ xl: 32, lg: 32, base: 16 }) || 16;
  const titleFontSize = useBreakpointValueGS({
    xl: theme.fontSizesPx['3xl'],
    lg: theme.fontSizesPx['3xl'],
    base: theme.fontSizesPx.lg,
  });

  return (
    <ScrollView>
      <View style={styles.container}>
        <HelpBackground />

        <View style={[styles.content, { paddingHorizontal: paddingX, gap: contentSpacing }]}>
          {Boolean(title) && (
            <Text style={[styles.title, { fontSize: titleFontSize, paddingHorizontal: 16 }]}>
              {title}
            </Text>
          )}

          <View style={styles.childrenContainer}>{children}</View>

          <View style={styles.footerContainer}>
            <HelperFooter />
          </View>
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    overflow: 'hidden',
    position: 'relative',
    justifyContent: 'space-between',
  },
  content: {
    flex: 1,
  },
  title: {
    color: theme.colors.base.white,
    fontWeight: 'bold',
    fontFamily: 'system-ui',
    lineHeight: 28,
  },
  childrenContainer: {
    flex: 1,
  },
  footerContainer: {
    paddingHorizontal: 16,
    paddingTop: 16,
  },
});

export default HelpPageLayout;
